<template>
	<div v-show="isShowIFrame">
		<div ref="pin"></div>
		<div ref="ifm" class="iframe-wrapper" :class="$root.siteRenderer">
			<iframe
				v-for="url in allIFrames"
				:src="url"
				:class="{visible: url === currentIFrame}"
			></iframe>
		</div>
	</div>
</template>


<script>
	import { mapGetters } from 'vuex'
	export default {
		props: {
			offset: {
				type: Number,
				default: 0
			}
		},
		computed: {
      ...mapGetters([
      	'isShowIFrame',
        'allIFrames',
				'currentIFrame'
    	])
		},
		mounted(){
			this.adjustIframePosition()
		},
		watch: {
			'isShowIFrame': {
				handler(val){
					this.adjustIframePosition()
				}
			},
			'currentIFrame': {
				handler(val){
					this.adjustIframePosition()
				}
			}
		},
		methods: {
			adjustIframePosition(){
				if(this.isShowIFrame) {
					this.$nextTick(()=>{
						let top = this.$refs.pin.offsetTop;
						let $ifm = this.$refs.ifm;
						if(this.$root.siteRenderer != 'pc') {
							if(top > 10) {
								top = top - 5
							}
						}
						$ifm.style['top'] = (top + parseFloat(this.offset)) + 'px'
					})
				}
			}
		}
	}
</script>
